interface FullNameProfile {
  first_name?: string;
  last_name?: string;
  [x: string | number | symbol]: any;
}

export type UserDisplayFields = {
  profile?: FullNameProfile | null;
  first_name?: string | null;
  last_name?: string | null;
  email?: string | null;
  username?: string | null;
};

export const fullName = (profile?: FullNameProfile) =>
  (profile?.first_name || '-') + ' ' + (profile?.last_name || '-');

const resolveDisplayName = (opts: UserDisplayFields): string => {
  const name = opts.profile
    ? fullName(opts.profile)
    : [opts.first_name ?? '', opts.last_name ?? ''].join(' ').trim();

  if (name && name !== '- -') return name.trim();
  return '';
};

export const getUserDisplayLines = (
  opts: UserDisplayFields
): { primary: string; secondary?: string } => {
  const name = resolveDisplayName(opts);
  const email = (opts.email ?? '').trim();

  if (name) {
    return email ? { primary: name, secondary: email } : { primary: name };
  }

  const username = (opts.username ?? '').trim();
  return { primary: email || username };
};

/**
 * Etykieta użytkownika: imię i nazwisko, a gdy brak – email, na końcu username.
 */
export const getUserDisplayLabel = (opts: UserDisplayFields): string => {
  const { primary } = getUserDisplayLines(opts);
  return primary;
};
